import './index.styl';
import template from './index.jst';
import { View } from 'backbone.marionette';
import { Model } from 'backbone';
import { GlobalNotifications } from '../../collections';
import { first } from 'lodash';
import LocalStorage from "../../utils/Storage/Local";

export class GlobalNotification extends View {
	get template() {
		return template;
	}

	get className(){
		return 'global-notification-popup';
	}

	ui(){
		return {
			close: '.js-close',
		}
	}

	events(){
		return {
			'click @ui.close': 'closePopup',
		}
	}

	get is_closed() {
		return JSON.parse(LocalStorage.get(this.notitication_data.text));
	}

	get notitication_data() {
		const notification_data_array = this.collection.toJSON();
		return first(notification_data_array);
	}

	initialize() {
		this.collection = new GlobalNotifications();
		this.model      = new Model({
			text: "",
			show: 0
		});

		this.fetchData();

		this.initListeners();
	}

	updateModel() {
		const notification_data = this.notitication_data;

		if (notification_data) {
			this.model.set({
				text: notification_data.text,
				show: notification_data.show && !this.is_closed
			});
		}
		return this;
	}

	fetchData() {
		return this.collection.fetch();
	}

	initListeners() {
		this.listenTo( this.collection, 'sync', this.updatePopUp );
		return this;
	}

	async updatePopUp() {
		this.updateModel()
			.render();
	}

	closePopup(){
		$('.global-notification-popup').hide();
		LocalStorage.set(this.notitication_data.text, true);
		return this;
	}
}

export default GlobalNotification;